<template>
  <div
    class="i-professional-bio-home"
    @click="isLargeScreen ? goToPersonality() : null"
  >
    <iBaseHeader
      highlight-text=""
      text="Professional Bio"
      font-size-text="16px"
      align="start"
    />
    <div class="bottom">
      <iBaseExpandableParagraph
        class="paragraph"
        :text="bioSummary"
        :text-size="descriptionFontSize"
        minified
        :collapsed-length="descriptionMaxlength"
      />
      <iBaseTextCta
        text="Read More"
        @cta-clicked="goToPersonality"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRouter } from "vue-router"
import { useReportStore } from "@/stores/report"
import { breakpointLg, breakpointMd, breakpointSm } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

import { GlobalVariables } from "@/helpers/globalVariables"

import iBaseHeader from "@/components/base/BaseHeader.vue"
import iBaseTextCta from "@/components/base/BaseTextCta.vue"
import iBaseExpandableParagraph from "@/components/base/BaseExpandableParagraph.vue"

// ROUTES
const router = useRouter()

// STORES AND COMPOSABLES
const reportStore = useReportStore()
const isMobileOrLarger = useIsScreenSize(breakpointSm)
const isTabletOrLarger = useIsScreenSize(breakpointMd)
const isLargeScreen = useIsScreenSize(breakpointLg)

// COMPUTED
const bioSummary = computed(() => reportStore.getBio ?? "Your professional bio is coming Soon...")
const descriptionFontSize = computed(() => (isLargeScreen.value ? "14px" : "16px"))
const descriptionMaxlength = computed(() =>
  isLargeScreen.value ? 350 : isTabletOrLarger.value ? 550 : isMobileOrLarger.value ? 350 : 200
)

// FUNCTIONS
const goToPersonality = () => {
  router.push({ name: GlobalVariables.urls.report.children.personality.routeName })
}
</script>

<style scoped lang="scss">
.i-professional-bio-home {
  @include flex(column, start, stretch, $gap: 15px);

  padding: 20px 20px 0;
  width: 100%;
  height: 100%;

  @media screen and (min-width: $breakpoint-lg) {
    cursor: pointer;
  }

  @media screen and (min-width: $breakpoint-lg) {
    padding: 20px;
    border-bottom: 1px solid $zumthor100;
    border-right: 1px solid $zumthor100;
  }

  .bottom {
    @include flex(column, start, stretch, $gap: 18px);

    height: calc(100% - 39px);
    padding-bottom: 20px;
    border-bottom: 1px solid $zumthor100;

    @media screen and (min-width: $breakpoint-lg) {
      padding-bottom: 0;
      border: none;
    }

    .paragraph {
      color: $pickle-bluewood800;
    }
  }
}
</style>
